import React from 'react';
import { Radio, RadioGroup, Text } from 'rsuite';
import { ValueType } from 'rsuite/esm/Radio';
import { PROPERTY_MANAGEMENT_OPTIONS } from 'src/components/payment/constants';
import { ExpressRegistrationRegistrant } from 'src/types/configuration';

interface PropertyManagerRadioGroupProps {
  configuration: ExpressRegistrationRegistrant;
  disabled?: boolean;
  isAdminUpdate?: boolean;
  isOwner?: boolean;
  isPropertyManager: boolean;
  isPropertyManagerDisabled?: boolean;
  isRegistrantTenant?: boolean;
  onChange: (value: PROPERTY_MANAGEMENT_OPTIONS) => void;
  value: PROPERTY_MANAGEMENT_OPTIONS;
}

export const PropertyManagerRadioGroup = ({
  configuration,
  disabled = false,
  isAdminUpdate = false,
  isOwner = false,
  isPropertyManager,
  isPropertyManagerDisabled = false,
  isRegistrantTenant = false,
  onChange,
  value,
}: PropertyManagerRadioGroupProps) => {
  const handleChange = (value: ValueType) => {
    onChange(value as PROPERTY_MANAGEMENT_OPTIONS);
  };

  return (
    <fieldset style={{ border: 'none', margin: 0, padding: 0 }}>
      <legend>
        <Text>Are you using a Property Manager for this property?</Text>
      </legend>
      <RadioGroup
        name="owner-radio-option-group"
        defaultValue={PROPERTY_MANAGEMENT_OPTIONS.SELF_MANAGED}
        value={value}
        onChange={handleChange}
        disabled={disabled}
      >
        <Radio value={PROPERTY_MANAGEMENT_OPTIONS.SELF_MANAGED}>
          Self Managed
        </Radio>
        {configuration.tenant && isRegistrantTenant && (
          <Radio value={PROPERTY_MANAGEMENT_OPTIONS.TENANT}>The tenant</Radio>
        )}
        {!isAdminUpdate && isPropertyManager && !isOwner && (
          <Radio value={PROPERTY_MANAGEMENT_OPTIONS.PROPERTY_MANAGER}>
            I'm the Property Manager
          </Radio>
        )}

        {(isAdminUpdate ||
          (isPropertyManagerDisabled === false &&
            (!isPropertyManager || isOwner))) && (
          <Radio value={PROPERTY_MANAGEMENT_OPTIONS.PROPERTY_MANAGER}>
            Yes, I'm using a Property Manager
          </Radio>
        )}
      </RadioGroup>
    </fieldset>
  );
};
